import { render, staticRenderFns } from "./ResultButton.vue?vue&type=template&id=f84f5718&lang=html"
import script from "./ResultButton.vue?vue&type=script&lang=js"
export * from "./ResultButton.vue?vue&type=script&lang=js"
import style0 from "./ResultButton.vue?vue&type=style&index=0&id=f84f5718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports